import { render, staticRenderFns } from "./PartnerPopup.vue?vue&type=template&id=5958df48"
import script from "./PartnerPopup.vue?vue&type=script&lang=js"
export * from "./PartnerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports